import {
  type schemaType,
  type paramsType,
  type returnType,
} from '~~/shared/api/rurality/v3/users/login/schema'
import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~~/modules/auth/stores/userStore'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/users/login'

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const result = await serverFetchWrapper<paramsType, schemaType>(
    endpoint,
    params,
  )
  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }
  return result
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const result = await browserFetchWrapper<paramsType, schemaType>(
    endpoint,
    params,
  )
  if (result.success) {
    const authUserIsLogged = await fetchUserIsLogged()
    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }
  return result
}
